"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DesktopBestOffers = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _utils = require("../../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DesktopBestOffers = ({
  content
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const analyticsData = (0, _react.useCallback)(url => () => {
    (0, _utils.logUserClick)(url);
  }, []);
  const itemsList = (0, _react.useMemo)(() => content?.map(item => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MainCategory, {
      "data-testid": getTestId(_constants.BEST_OFFERS_SUB_HEADLINE),
      variant: "subtitle1",
      href: item.url,
      onClick: analyticsData(item.url),
      children: item.title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      children: item.children.map(child => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubItem, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SubLink, {
          "data-testid": getTestId(_constants.BEST_OFFERS_SUB_LINK),
          href: child.url,
          onClick: analyticsData(child.url),
          children: child.title
        })
      }, child.id))
    })]
  }, item.id)), [analyticsData, content, getTestId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.BEST_OFFERS_SUBMENU),
    children: itemsList
  });
};
exports.DesktopBestOffers = DesktopBestOffers;
